export default {
  report: {
    name: '我的报表',
    prop: {
      serial_number: '编号',
      name: '名称',
      report_type: '报表类型',
      statistics_time_range: '统计时间',
      created_at: '导出时间',
      charge_stations: '统计的电站',
      service_provider: '统计的运营商'
    },
    // enum
    report_types: {
      // station_operation_report: '单一电站运营报表',
      // charger_operation: '充电运营报表',
      // charger_operation_pdf: '充电运营报表（PDF）',
      user_consumption: '用户消费报表',
      station_operation: '单一电站运营报表',
      financial_reconciliation: '财务对账报表'
    },
    report_history_types: {
      station_operation_report: '单一电站运营报表',
      charger_operation: '充电运营报表',
      charger_operation_pdf: '充电运营报表（PDF）',
      user_consumption: '用户消费报表',
      station_operation: '单一电站运营报表',
      financial_reconciliation: '财务对账报表'
    },
    placeholder: {
      input_name: '输入报表名'
    },
    group_titles: {
      base: '基本信息'
    },
    labels: {
      create: '生成'
    }
  }
}
